<div class="dm-card-wrap" *ngIf="choice && option">
  <div
    class="dm-card dm-card--full ion-activatable"
    (click)="
      !option.availableTotal ||
      !choice.availableTotal ||
      (option.dependenciesVariable &&
        option.dependenciesVariable.length > 0 &&
        !option.dependentHidden &&
        !option.showDependent)
        ? null
        : selectChoice()
    "
    [ngClass]="{
      'dm-card--selected': !!choice.is_preselected,
      'dm-card--disabled': !!(
        !option.availableTotal ||
        !choice.availableTotal ||
        (option.dependenciesVariable &&
          option.dependenciesVariable.length > 0 &&
          !option.dependentHidden &&
          !option.showDependent)
      ),
      'dm-card--line-through': !!(!option.availableTotal || !choice.availableTotal)
    }"
  >
    <div class="dm-card__tags">
      <app-product-choice-tags
        [choiceItem]="choice"
        [optionItem]="option"
        [selectedProductPromo]="selectedProductPromo"
        [groupStoreData]="groupStoreData"
      >
      </app-product-choice-tags>
    </div>

    <div class="dm-card__img" *ngIf="imagePath">
      <img [alt]="choice.title" loading="lazy" [src]="imagePath" />
    </div>

    <div class="dm-card__body">
      <div class="dm-card__title">
        {{ choice.title }}
        <ion-icon
          [color]="
            groupStoreData &&
            groupStoreData.store_info &&
            groupStoreData.store_info.design_settings &&
            groupStoreData.store_info.design_settings.tagsColors &&
            groupStoreData.store_info.design_settings.tagsColors.frozen
              ? groupStoreData.store_info.design_settings.tagsColors.frozen
              : 'primary'
          "
          class="badge-margin"
          style="font-size: 13px; vertical-align: middle"
          src="assets/flatIcons/frozen.svg"
          *ngIf="choice.tags && choice.tags.frozen"
        ></ion-icon>
      </div>

      <div class="dm-card__price">
        <ion-text color="primary">
          <span
            *ngIf="
              ((orderPickup == false && dineIn == false) ||
                (orderPickup == null && dineIn == null) ||
                (orderPickup == true &&
                  dineIn == false &&
                  !choice.price_takeaway) ||
                (orderPickup == false &&
                  dineIn == true &&
                  (!alt_dinein_active ||
                    !selectedDineInTable ||
                    !selectedDineInTable.alt_dinein) &&
                  !choice.price_dinein) ||
                (orderPickup == false &&
                  dineIn == true &&
                  alt_dinein_active &&
                  selectedDineInTable &&
                  selectedDineInTable.alt_dinein &&
                  !choice.price_alt_dinein)) &&
              choice.price.toString().trim().replace(',', '.') < 0
            "
            >{{
              choice.price.toString().trim().replace(",", ".")
                | number : "1.2-2"
            }}€</span
          >
          <span
            *ngIf="
              ((orderPickup == false && dineIn == false) ||
                (orderPickup == null && dineIn == null) ||
                (orderPickup == true &&
                  dineIn == false &&
                  !choice.price_takeaway) ||
                (orderPickup == false &&
                  dineIn == true &&
                  (!alt_dinein_active ||
                    !selectedDineInTable ||
                    !selectedDineInTable.alt_dinein) &&
                  !choice.price_dinein) ||
                (orderPickup == false &&
                  dineIn == true &&
                  alt_dinein_active &&
                  selectedDineInTable &&
                  selectedDineInTable.alt_dinein &&
                  !choice.price_alt_dinein)) &&
              choice.price.toString().trim().replace(',', '.') > 0
            "
            >{{ !option.changesBasePrice ? "+" : ""
            }}{{
              choice.price.toString().trim().replace(",", ".")
                | number : "1.2-2"
            }}€</span
          >
          <span
            *ngIf="
              orderPickup == true &&
              dineIn == false &&
              choice.price_takeaway &&
              choice.price_takeaway.toString().trim().replace(',', '.') < 0
            "
            >{{
              choice.price_takeaway.toString().trim().replace(",", ".")
                | number : "1.2-2"
            }}€</span
          >
          <span
            *ngIf="
              orderPickup == true &&
              dineIn == false &&
              choice.price_takeaway &&
              choice.price_takeaway.toString().trim().replace(',', '.') > 0
            "
            >{{ !option.changesBasePrice ? "+" : ""
            }}{{
              choice.price_takeaway.toString().trim().replace(",", ".")
                | number : "1.2-2"
            }}€</span
          >
          <span
            *ngIf="
              orderPickup == false &&
              dineIn == true &&
              choice.price_dinein &&
              (!alt_dinein_active ||
                !selectedDineInTable ||
                !selectedDineInTable.alt_dinein ||
                !choice.price_alt_dinein) &&
              choice.price_dinein.toString().trim().replace(',', '.') < 0
            "
            >{{
              choice.price_dinein.toString().trim().replace(",", ".")
                | number : "1.2-2"
            }}€</span
          >
          <span
            *ngIf="
              orderPickup == false &&
              dineIn == true &&
              (!alt_dinein_active ||
                !selectedDineInTable ||
                !selectedDineInTable.alt_dinein ||
                !choice.price_alt_dinein) &&
              choice.price_dinein &&
              choice.price_dinein.toString().trim().replace(',', '.') > 0
            "
            >{{ !option.changesBasePrice ? "+" : ""
            }}{{
              choice.price_dinein.toString().trim().replace(",", ".")
                | number : "1.2-2"
            }}€</span
          >
          <span
            *ngIf="
              orderPickup == false &&
              dineIn == true &&
              choice.price_alt_dinein &&
              alt_dinein_active &&
              selectedDineInTable &&
              selectedDineInTable.alt_dinein &&
              choice.price_alt_dinein.toString().trim().replace(',', '.') < 0
            "
            >{{
              choice.price_alt_dinein.toString().trim().replace(",", ".")
                | number : "1.2-2"
            }}€</span
          >
          <span
            *ngIf="
              orderPickup == false &&
              dineIn == true &&
              choice.price_alt_dinein &&
              alt_dinein_active &&
              selectedDineInTable &&
              selectedDineInTable.alt_dinein &&
              choice.price_alt_dinein.toString().trim().replace(',', '.') > 0
            "
            >{{ !option.changesBasePrice ? "+" : ""
            }}{{
              choice.price_alt_dinein.toString().trim().replace(",", ".")
                | number : "1.2-2"
            }}€</span
          >
        </ion-text>
      </div>
    </div>

    <ion-ripple-effect></ion-ripple-effect>
  </div>
</div>
